import React from 'react';
import styled from 'styled-components';
import { YouTube, Instagram, LinkedIn,} from '@mui/icons-material';
import { config } from '../config';

const FooterWrapper = styled.footer`
  background: #F19F4D;
  color: white;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const FooterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  max-width: 1200px;
  margin: 0 20px;
  width: 100%;
  flex-wrap: wrap;
  gap: 50px; /* Gap between the columns */

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 5px;
  }
`;

const LogoSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  margin-bottom: 20px;
  justify-content: center;

  @media (max-width: 768px) {
    order: -1;
    margin-top: 10px;
  }
`;

const Logo = styled.img`
  height: 100px;
  margin-bottom: 10px;
  width: auto;
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 25px;
  justify-content: center;
  margin-top: 10px;

  @media (max-width: 768px) {
    gap: 20px;
    flex-wrap: wrap;
  }
`;

const StyledIcon = styled.a`
  color: white;
  font-size: 30px;
  transition: color 0.5s ease;
  &:hover {
    color:rgb(0, 0, 0);
  }
`;

const FooterColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  flex: 1;
  margin-bottom: 10px;
  margin-top: 39px;

  @media (max-width: 768px) {
    margin-top: 0;
    gap: 10px;
  }
`;

const FooterLink = styled.a`
  color: white;
  text-decoration: none;
  margin-bottom: 20px;
  font-size: 19px;
  align-items: center;
  font-weight: 500;
  text-align: center;
  &:hover {
  text-decoration: underline;
  }

  @media (max-width: 768px) {
    margin-bottom: 10px;
    font-size: 18px;
  }
`;

// Media Queries for Responsiveness
const Footer = () => (
  <FooterWrapper>
    <FooterContainer>
      {/* Logo Section */}
      <LogoSection>
        <Logo src={config?.logoSrc || ''} alt="Logo" />
        <h4 style={{margin: 0}}>Follow Us On</h4>
        <SocialIcons>
          {config?.socialLinks?.[2]?.url && <StyledIcon href="https://www.youtube.com/@code-kalakar" target="_blank" rel="noopener noreferrer"><YouTube /></StyledIcon>}
          {config?.socialLinks?.[1]?.url && <StyledIcon href="https://www.instagram.com/willovate_/?utm_source=ig_web_button_share_sheet" target="_blank" rel="noopener noreferrer"><Instagram /></StyledIcon>}
          {config?.socialLinks?.[3]?.url && <StyledIcon href="https://www.linkedin.com/company/willovate-private-limited/?viewAsMember=true" target="_blank" rel="noopener noreferrer"><LinkedIn /></StyledIcon>}
        </SocialIcons>
      </LogoSection>

      {/* Footer Columns */}
      <FooterColumn>
        {config?.footerLinks?.map((link, index) => (
          <FooterLink key={index} href={link?.link || '#'}>{link?.label || 'Link'}</FooterLink>
        ))}
      </FooterColumn>

      <FooterColumn>
        <FooterLink>Ongoing Content</FooterLink>
        <FooterLink>Upcoming</FooterLink>
        <FooterLink>Stipended Based</FooterLink>
      </FooterColumn>

    </FooterContainer>
  </FooterWrapper>
);

export default Footer;
